import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'

export const TaxConsultantService = {
  get: () => {
    return new Promise((resolve, reject) => {
      request(config.getTaxConsultant, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  resendCollaborationInvitation: (tenantCollaborationId) => {
    return new Promise((resolve, reject) => {
      request(`${config.resendCollaborationInvitation}/${tenantCollaborationId}`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  setConnectionStatus: (tenantCollaborationId, status) => {
    return new Promise((resolve, reject) => {
      request(`${config.setConnectionStatus}/${tenantCollaborationId}`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { status },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  restoreCollaboration: (tenantCollaborationId, clerkIds = []) => {
    return new Promise((resolve, reject) => {
      request(`${config.restoreCollaboration}/${tenantCollaborationId}`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { clerkIds },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  disconnect: (tenantCollaborationId) => {
    return new Promise((resolve, reject) => {
      request(config.disconnectTaxConsultant, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { tenantCollaborationId },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  searchTaxConsultant: (email) => {
    return new Promise((resolve, reject) => {
      request(config.searchTaxConsultant, {
        auth: true,
        isConcurrent: true,
        data: { email },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  invite: (email, tenantId) => {
    return new Promise((resolve, reject) => {
      request(config.inviteTaxConsultant, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: { email, tenantId },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
}
